import { Component, OnInit } from '@angular/core';
import { FrattaleService } from 'src/app/services/frattale.service';

@Component({
  selector: 'app-lista-report',
  templateUrl: './lista-report.component.html',
  styleUrls: ['./lista-report.component.scss']
})
export class ListaReportComponent implements OnInit {

  reports: any = []

  constructor(private service: FrattaleService) { }

  ngOnInit(): void {
  }

  aggiungiReport() {
    //console.log("aggiungiReport");
  }

  modificaReport(id: number) {
    //console.log("modificaReport");
  }
}
